import { useEffect, useState } from "react";

import type { OpenAPI } from "simplydo/interfaces";
import { Button, Loader } from "simplydo/react/ui";

import api from "api";

import ChallengeOverview from "components/challenges/Challenge/Overview";
import type { GenAIChallengeDraft } from "components/challenges/types";

import type { IdeaChallengeHelpProps } from "./types";

const IdeaChallengeHelp = ({
  closeHelp,
  challengeId,
}: IdeaChallengeHelpProps) => {
  const [loading, setLoading] = useState(false);
  const [challenge, setChallenge] = useState<
    OpenAPI.GET<"/challenges/{id}/overview">["response"] | null
  >(null);

  useEffect(() => {
    setLoading(true);
    api.challenges.getOverview(
      challengeId,
      {},
      (newChallenge) => {
        setChallenge(newChallenge);
        setLoading(false);
      },
      () => setLoading(false),
    );
  }, [challengeId]);

  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginBottom: 10,
        }}
      >
        <Button icon="close" color="red" onClick={closeHelp} />
      </div>
      {loading ? (
        <Loader active={loading} />
      ) : challenge ? (
        <ChallengeOverview
          challenge={challenge as GenAIChallengeDraft}
          isPreview
        />
      ) : null}
    </div>
  );
};

export default IdeaChallengeHelp;
